import type { StampVariant } from '../ui/index.js'

/** Shared by the Runs list and Home's recent-activity preview — one mapping, not two. */
export function verdictStampVariant(verdict: string): StampVariant {
  switch (verdict) {
    case 'confirmed':
      return 'ok'
    case 'needs_you':
      return 'warn'
    case 'refused':
    case 'mismatch':
      return 'stop'
    // Listed explicitly rather than left to the fallback: `you` reads
    // "Ambiguous — needs a ruling", which is a claim about what the operator
    // must do. Nothing is waiting on anyone here.
    case 'not_confirmed_yet':
      return 'open'
    default:
      return 'you'
  }
}
